"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.curry = void 0;

/**
 * Partially apply a function
 *
 * @signature (...args: mixed[]): Function|mixed
 *
 * @param {Function}  fn    The function to apply
 * @param {any}       args  The arguments to apply, in order
 *
 * @return  {Function|mixed}  If the number of arguments provided is sufficient
 * to call the function, call the function and return the result. Otherwise,
 * return a new function which takes additional parameters, returning the result
 * of calling `curry` on the function with the provided parameters.
 *
 * @example
 * const sum = (a, b) => a + b
 *
 * curry(sum)(1)(2) = 3
 */
var curry = function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length >= fn.length ? fn.apply(void 0, args) : function () {
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }

      return curry(fn).apply(void 0, args.concat(rest));
    };
  };
};

exports.curry = curry;